import { useMemo } from 'react';
import tinycolor from 'tinycolor2';
import {
  DARK_DOMINANT_COLOR_BRIGHTNESS,
  DEFAULT_DOMINANT_BACKGROUND_COLOR,
} from '@utils/constants';

export function useGetDominantBackgroundColor({
  dominantColor,
}: {
  dominantColor: string | null | undefined;
}) {
  const dominantColorBrightness = useMemo(() => {
    return dominantColor ? tinycolor(dominantColor).getBrightness() : null;
  }, [dominantColor]);

  const dominantBackgroundColor =
    dominantColorBrightness !== null && dominantColorBrightness <= DARK_DOMINANT_COLOR_BRIGHTNESS
      ? DEFAULT_DOMINANT_BACKGROUND_COLOR
      : dominantColor;

  return dominantBackgroundColor ?? DEFAULT_DOMINANT_BACKGROUND_COLOR;
}
